import {get} from 'lodash'
import {userHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'
import uuid from 'helpers/uuid'
import {Posted_Invoice_Status} from "helpers/invoices"
import {isProPurchasingEnabled} from "helpers/purchasing/purchaseOrders"

export const createNewPurchaseInvoiceItem = (purchaseInvoice, defaultNominalCode) => {
  return {
    id: uuid(),
    purchaseInvoiceId: get(purchaseInvoice, 'id', null),
    purchaseOrderItemId: null,
    purchaseOrderRef: null,
    sortOrder: 0,
    nominalCode: defaultNominalCode,
    departmentName: null,
    notes: null,
    packType: 'Unit(s)',
    unitCost: 0,
    quantity: 1,
    totalCost: 0,
    totalTax: 0,
    taxCodeId: get(purchaseInvoice, 'taxCodeId', null),
    taxRate: get(purchaseInvoice, 'taxRate', 0),
    guid: uuid(),
  }
}

export const getContractTotal = (purchaseInvoice) => {
  const purchaseOrder = get(purchaseInvoice, 'purchaseOrder', null)
  return purchaseOrder
      ? get(purchaseOrder, 'totalCost', 0) + get(purchaseOrder, 'subTotalTax', 0)
      : 0
}

export const getInvoicedTotal = (purchaseInvoice) => {
  return get(purchaseInvoice, 'values.discountedPriceIncTax', 0)
}

export const getInvoicedPercentage = (contractTotal, invoicedTotal) => {
  return contractTotal > 0 ? ((invoicedTotal / contractTotal) * 100) : 100
}

export const canEditPurchaseInvoice = (user, purchaseInvoice) => {
  const isPosted = get(purchaseInvoice, 'posted', false)
  const postStatus = get(purchaseInvoice, 'postStatus.value', "")
  const isSyncing = isProPurchasingEnabled(user)
  const isPurchasingLicenceEnabled = userHasFeature(user, features.PURCHASING_LICENCE)

  return !isPosted
      && postStatus !== Posted_Invoice_Status.PENDING
      && !isSyncing
      && isPurchasingLicenceEnabled
}

export const canEditPurchaseInvoiceForPosting = (user, purchaseInvoice) => {
  const isPosted = get(purchaseInvoice, 'posted', false)
  const proSync = get(user, 'proSync', false)
  const isPurchasingLicenceEnabled = proSync ? true : userHasFeature(user, features.PURCHASING_LICENCE)
  return !isPosted && isPurchasingLicenceEnabled
}

export const canRepostPurchaseInvoice = (user) => {
  const proSync = get(user, 'proSync', false)
  return proSync ? true : userHasFeature(user, features.PURCHASING_LICENCE)
}

export const isSupplierRefMandatory = (requiredFields) => {
  return get(requiredFields, 'PURCHASE_INVOICE_SUPPLIER_REFERENCE')
}
